import React, { useEffect } from "react";
import { Box, Stack } from "@mui/material";
import Styles from "./Home.module.css";

declare module "react" {
  interface VideoHTMLAttributes<T> extends React.HTMLAttributes<T> {
    fetchPriority?: "high" | "low" | "auto";
  }
}

const desktopWhoGif =
  "https://firebasestorage.googleapis.com/v0/b/onestolabs-09.firebasestorage.app/o/main-video%2FDesktop.gif?alt=media&token=500a600f-8bcd-4d08-bd3e-e6f6dd7791b6";

const mobileWhoGif =
  "https://firebasestorage.googleapis.com/v0/b/onestolabs-09.firebasestorage.app/o/main-video%2FMobile.gif?alt=media&token=28a1b8db-2b9c-4651-bf54-639c463325cc";

const pillarData = [
  {
    number: "01",
    title: "Clean Formulations",
    description:
      "We say no to parabens, sulphates — and lesser-known offenders like MCIT and MIT. Every formula meets a strict no-list that we proudly display on every product page.",
    tag: "No Harmful Ingredients",
    image:
      "https://firebasestorage.googleapis.com/v0/b/onestolabs-09.firebasestorage.app/o/Pillar%2F1.jpg?alt=media&token=ce44d741-7425-4b86-8ea9-f8dd88db9670",
  },
  {
    number: "02",
    title: "Complete Transparency",
    description:
      "We disclose every ingredient, every study report, and the data from all clinical trials. Your skincare decisions should never be made in the dark.",
    tag: "Full Ingredients Disclosure",
    image:
      "https://firebasestorage.googleapis.com/v0/b/onestolabs-09.firebasestorage.app/o/Pillar%2F2.jpg?alt=media&token=06bd3c88-0baa-4d16-b5b3-038f6faf58ea",
  },
  {
    number: "03",
    title: "Science-First Innovation",
    description:
      "From lab ideation to clinical trials, every formula is tested and refined. Our in-house R&D team ensures we stay effective, safe, and ahead in innovation.",
    tag: "Clinically Tested",
    image:
      "https://firebasestorage.googleapis.com/v0/b/onestolabs-09.firebasestorage.app/o/Pillar%2F3.jpg?alt=media&token=dfab1206-68a8-4d49-b50b-faf8381e6441",
  },
];

const brandData = [
  {
    image:
      "https://firebasestorage.googleapis.com/v0/b/onestolabs-09.firebasestorage.app/o/main-video%2FBA%20(1).jpg?alt=media&token=f7867973-a192-4fcf-81a9-01b85fa49b0f",
    alt: "Bare Anatomy",
    url: "https://innovist.com/pages/bare-anatomy-store",
  },
  {
    image:
      "https://firebasestorage.googleapis.com/v0/b/onestolabs-09.firebasestorage.app/o/main-video%2FCAP%20(2).jpg?alt=media&token=ffe6da90-aafe-4914-920a-7f6d8b81675f",
    alt: "Chemist at Play",
    url: "https://innovist.com/pages/chemist-at-play-store",
  },
  {
    image:
      "https://firebasestorage.googleapis.com/v0/b/onestolabs-09.firebasestorage.app/o/main-video%2FSS%20(1).jpg?alt=media&token=23ea17f2-3bf0-499a-953d-8aa352d552c0",
    alt: "Sunscoop",
    url: "https://innovist.com/pages/sunscoop-store",
  },
];

const valuesData = [
  {
    title: "Our Mission",
    description:
      "We believe that personal care should be as intelligent as it is intentional. We exist to bridge the gap between what people are told and what actually works. To educate consumers about how ingredients function, how products are tested, and what goes into making formulas that are not just safe, but truly effective.",
    mediaType: "video",
    image:
      "https://firebasestorage.googleapis.com/v0/b/onestolabs-09.firebasestorage.app/o/values%2F88a83e12daf94cefb51615c71a16a29b.SD-480p-1.2Mbps-55100520.mp4?alt=media&token=a9a8d1d0-4a23-46d1-9f32-bdc0ea80d1a4",
  },
  {
    title: "Our Commitment",
    description:
      "We don’t just make products but stand behind how they’re made. Innovist is committed to clean, cruelty-free formulations backed by science, with full transparency in sourcing and sustainability at the core of our packaging and practices.",
    mediaType: "image",
    image:
      "https://firebasestorage.googleapis.com/v0/b/onestolabs-09.firebasestorage.app/o/values%2F2.webp?alt=media&token=2e4d5f3f-ebc7-4766-80b3-fcab84dc1021",
  },
  {
    title: "In-House R&D and Manufacturing Facility",
    description:
      "From concept to creation, everything happens in-house at Innovist. Our R&D and manufacturing facility allows us to craft, test, and refine every formula with precision. This level of control helps us maintain EU-grade safety standards and stay fully transparent with what goes into every product.",
    mediaType: "image",
    image:
      "https://firebasestorage.googleapis.com/v0/b/onestolabs-09.firebasestorage.app/o/values%2F3.webp?alt=media&token=1b94d38b-7cd4-4ad4-bc9c-3653a50a43b2",
  },
  {
    title: "Why Choose Us ?",
    description:
      "Because we go beyond clean claims. At Innovist, every product is driven by science, clinically tested, and made with clean, safe ingredients. We’re fully transparent, right down to the percentages, so you always know what you're using and why it works. It’s personal care that’s honest, effective, and built on trust.",
    mediaType: "image",
    image:
      "https://firebasestorage.googleapis.com/v0/b/onestolabs-09.firebasestorage.app/o/values%2F5.webp?alt=media&token=6a3187b8-d91d-4805-ac5e-b7f21ad6020b",
  },
];

const foundersData = [
  {
    name: "Rohit Chawla",
    designation: "Founder & Chief Executive Officer",
    details: [
      "Founder, The Man Company",
      "INSEAD and Carnegie Mellon University",
    ],
    image:
      "https://firebasestorage.googleapis.com/v0/b/onestolabs-09.firebasestorage.app/o/Founders%2Frohit.png?alt=media&token=2e018297-d810-4610-bdb6-53f29208f43b",
    linkedin: "http://linkedin.com/in/rchawla/",
  },
  {
    name: "Sifat Khurana",
    designation: "Co-Founder & Chief Branding Officer",
    details: [
      "Ex-Ogilvy, Ex-Leo Burnett",
      "National Institute of Fashion Technology",
    ],
    image:
      "https://firebasestorage.googleapis.com/v0/b/onestolabs-09.firebasestorage.app/o/Founders%2Fsifat.png?alt=media&token=63de4641-ead9-459d-83b6-1af648e22c68",
    linkedin: "https://www.linkedin.com/in/sifatkhurana/",
  },
  {
    name: "Vimal Bhola",
    designation: "Co-Founder & Chief Scientist",
    details: ["Ex-Johnson & Johnson, Ex-Unilever", "Robert Gordon University"],
    image:
      "https://firebasestorage.googleapis.com/v0/b/onestolabs-09.firebasestorage.app/o/Founders%2Fvimal.png?alt=media&token=e74935b0-9067-4a58-be6d-283c27257e39",
    linkedin: "http://linkedin.com/in/vimal-bhola-07043410/",
  },
];

const Home: React.FC = () => {



  return (
    <Box className={Styles.main_container}>
      {/* Who Are We Section */}
      <Box className={Styles.who_section}>
        <Box className={Styles.who_gif_wrap}>
          <picture>
            <source media="(max-width: 767px)" srcSet={mobileWhoGif} />
            <img
              src={desktopWhoGif}
              alt="Onesto Labs R&D"
              className={Styles.who_gif}
            />
          </picture>
        </Box>

        <Stack className={Styles.section_text_center}>
          <Box className={Styles.section_title}>Who Are We?</Box>

          <Box className={Styles.section_description}>
            Onesto Labs is the research, innovation, and manufacturing
            powerhouse behind Innovist. Built on the belief that great personal
            care starts with honest science, Onesto Labs develops every
            formulation through in-house research, rigorous testing, and a
            commitment to ingredient transparency.
            <br />
            <br />
            Under Innovist, we bring this expertise to life through
            purpose-driven brands like Bare Anatomy, Chemist at Play, and
            SunScoop, each created to solve real haircare, skincare, and sun
            care concerns with clinically backed, effective formulations. From
            concept to creation, every product reflects our focus on science,
            quality, and results you can trust.
          </Box>

          <Box
            component="a"
            href="https://innovist.com"
            target="_blank"
            rel="noopener noreferrer"
            className={Styles.explore_products_btn}
          >
            Explore Our Products
          </Box>
        </Stack>
      </Box>

      {/* What We Stand For Section */}
      <Box className={Styles.container_1200}>
        <Box className={Styles.section_container}>
          <Stack className={Styles.section_heading}>
            <Box className={Styles.section_small_title}>What We Stand For</Box>
            <Box className={Styles.section_main_title}>
              Three Pillars. One Promise.
            </Box>
          </Stack>

          <Box className={Styles.pillar_grid}>
            {pillarData.map((item) => (
              <Stack className={Styles.pillar_card} key={item.number}>
                <Box className={Styles.pillar_top_row}>
                  <Box className={Styles.pillar_icon_box}>
                    <img
                      src={item.image}
                      alt={item.title}
                      className={Styles.pillar_icon}
                    />
                  </Box>

                  <Box className={Styles.pillar_number}>{item.number}</Box>
                </Box>

                <Box className={Styles.pillar_title}>{item.title}</Box>

                <Box className={Styles.pillar_description}>
                  {item.description}
                </Box>

                <Box className={Styles.pillar_tag}>{item.tag}</Box>
              </Stack>
            ))}
          </Box>
        </Box>
      </Box>

      {/* Brand That Lead Section */}
      <Box className={Styles.container_1200}>
        <Box className={Styles.section_container}>
          <Box className={Styles.brand_title}>
            <span>Brands</span> That Lead
          </Box>

          <Box className={Styles.brand_grid}>
            {brandData.map((item) => (
              <Box
                key={item.alt}
                component="a"
                href={item.url}
                target="_blank"
                rel="noopener noreferrer"
                className={Styles.brand_card}
              >
                <img
                  src={item.image}
                  alt={item.alt}
                  className={Styles.brand_image}
                />
              </Box>
            ))}
          </Box>
        </Box>
      </Box>

      {/* Our Values Section */}
      <Box className={Styles.values_section}>
        <Box className={Styles.container_1200}>
          <Stack className={Styles.values_heading}>
            <Box className={Styles.values_title}>Our Values</Box>
            <Box className={Styles.values_subtitle}>
              Evidence-led. Ingredient-honest. Efficacy-first.
            </Box>
          </Stack>

          <Stack className={Styles.values_cards}>
            {valuesData.map((item, index) => (
              <Box
                key={item.title}
                className={`${Styles.value_card} ${
                  index % 2 !== 0 ? Styles.value_card_reverse : ""
                }`}
              >
                <Box className={Styles.value_content}>
                  <Box className={Styles.value_card_title}>{item.title}</Box>
                  <Box className={Styles.value_card_description}>
                    {item.description}
                  </Box>
                </Box>

                <Box className={Styles.value_image_wrap}>
                  {item.mediaType === "video" ? (
                    <video
                      src={item.image}
                      className={Styles.value_image}
                      muted
                      loop
                      playsInline
                      controls
                    />
                  ) : (
                    <img
                      src={item.image}
                      alt={item.title}
                      className={Styles.value_image}
                    />
                  )}
                </Box>
              </Box>
            ))}
          </Stack>
        </Box>
      </Box>

      {/* Founders Section */}
      <Box className={Styles.founders_section}>
        <Box className={Styles.container_1200}>
          <Stack className={Styles.founders_heading}>
            <Box className={Styles.founders_title}>The Visionaries</Box>
            <Box className={Styles.founders_subtitle}>
              Steered by the Best Minds in the Business
            </Box>
          </Stack>

          <Box className={Styles.founders_grid}>
            {foundersData.map((item) => (
              <Stack className={Styles.founder_card} key={item.name}>
                <Box className={Styles.founder_image_wrap}>
                  <img
                    src={item.image}
                    alt={item.name}
                    className={Styles.founder_image}
                  />
                </Box>

                <Stack className={Styles.founder_content}>
                  <Box className={Styles.founder_text}>
                    <Box className={Styles.founder_name}>{item.name}</Box>
                    <Box className={Styles.founder_designation}>
                      {item.designation}
                    </Box>

                    {item.details.map((detail) => (
                      <Box className={Styles.founder_detail} key={detail}>
                        {detail}
                      </Box>
                    ))}
                  </Box>

                  <Box
                    component="a"
                    href={item.linkedin}
                    target="_blank"
                    rel="noopener noreferrer"
                    className={Styles.linkedin_link}
                  >
                    in
                  </Box>
                </Stack>
              </Stack>
            ))}
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default Home;
